import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ChevronDown, PhoneCall, MessageCircle } from 'lucide-react';

const Services = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [coursesOpen, setCoursesOpen] = useState(false);

  return (
    <div className="bg-[#f7f6f3] text-gray-800 font-sans">
      {/* Header Bar */}
      <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
        <div className="flex flex-col md:flex-row items-center gap-2">
          <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">
            📧 admin@kentacademy.co.uk
          </a>
        </div>
        <a
          href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
           className="text-white hover:underline flex items-center gap-1"
        >
          <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
          facebook.com/KentAcademy
        </a>
      </div>

      {/* Navigation */}
      <nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
        <Link to="/" className="cursor-pointer">
  <img
    src="/assets/KaLogo.png"
    alt="Kent Academy"
    className="h-40 w-auto object-contain"
  />
</Link>

        </div>
        
        {/* Desktop Nav */}
        <div className="bg-[#f7f6f3] border-t border-gray-200 hidden md:flex">
          <div className="max-w-4xl mx-auto px-4 flex justify-between items-center text-sm font-medium py-3 relative w-full">
            <Link to="/" className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
            <Link to="/about" className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
            
            <div
              className="relative cursor-pointer group"
              onMouseEnter={() => setCoursesOpen(true)}
              onMouseLeave={() => setCoursesOpen(false)}
            >
              <div className="flex items-center gap-1 text-gray-800 hover:text-black transition-colors duration-200">
                <span>ALL COURSES</span>
                <ChevronDown 
                  size={16} 
                  className={`transition-transform duration-200 ${coursesOpen ? 'rotate-180' : ''}`}
                />
              </div>
              
              {/* Dropdown */}
              <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 transition-all duration-200 z-50 ${
                coursesOpen 
                  ? 'opacity-100 visible translate-y-0' 
                  : 'opacity-0 invisible -translate-y-2'
              }`}>
                <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45"></div>
                
                <div className="bg-white border border-gray-200 rounded-md shadow-lg w-64 overflow-hidden">
                  <div className="py-1">
                    <a 
                      href="#laser" 
                      className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        <div>
                          <h4 className="font-medium text-gray-900 text-sm">Level 4 in Laser and Light</h4>
                          <p className="text-xs text-gray-600">Professional laser training</p>
                        </div>
                      </div>
                    </a>
                    
                    <a 
                      href="#tattoo" 
                      className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                        <div>
                          <h4 className="font-medium text-gray-900 text-sm">Level 5 in Tattoo Removal</h4>
                          <p className="text-xs text-gray-600">CPD and Level 5 available</p>
                        </div>
                      </div>
                    </a>
                    
                    <a 
                      href="#nails" 
                      className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-pink-600 rounded-full"></div>
                        <div>
                          <h4 className="font-medium text-gray-900 text-sm">Level 3 in Nail Technology</h4>
                          <p className="text-xs text-gray-600">Bilingual training for UK professionals</p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <Link to="/contact" className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
          </div>
        </div>

        {/* Mobile Dropdown Toggle */}
        <div className="md:hidden flex justify-center pb-3">
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="text-sm border px-4 py-2 rounded text-gray-800 border-gray-600 hover:bg-gray-100 transition-colors duration-200"
          >
            {mobileOpen ? 'Close Menu' : 'Menu'}
          </button>
        </div>

        {/* Mobile Dropdown Nav */}
        {mobileOpen && (
          <div className="md:hidden bg-[#f7f6f3] border-t border-gray-200 px-6 py-4 flex flex-col items-center gap-3 text-sm font-medium">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
            <Link to="/about" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
            <Link to="/services" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">ALL COURSES</Link>
            <Link to="/contact" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
            <a
              href="mailto:admin@kentacademy.co.uk"
              className="inline-block border border-gray-800 text-gray-800 px-3 py-1 rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
            >
              Contact Us
            </a>
          </div>
        )}
      </nav>

      {/* Header */}
      <section className="relative pt-44 pb-16 px-6 w-full">
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-light mb-6">
            OUR <span className="font-semibold">COURSES</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            Professional beauty training with industry-leading equipment and expert guidance. Transform your career with our accredited courses.
          </p>
        </div>
      </section>

      {/* Laser & IPL Course Section */}
      <section id="laser" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-light mb-6">
                Level 4 in <span className="font-semibold">Laser and IPL</span>
              </h2>
              <p className="text-2xl font-semibold text-blue-600 mb-6">£1,495.00</p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Step into the world of professional aesthetics with our Level 4 Laser Hair Removal Course, designed for those who want to master the most in-demand treatment in the beauty industry. Whether you're an experienced therapist or looking to upskill, our comprehensive training is tailored to provide real, practical knowledge that delivers results.
              </p>
              
              <h3 className="text-xl font-semibold mb-4">Why Choose Us?</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Taught by Industry Professionals</p>
                    <p className="text-gray-700 text-sm">Our training is led by experts with over 30 years of hands-on experience in aesthetics and laser technology.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Accredited Level 4 Curriculum</p>
                    <p className="text-gray-700 text-sm">Aligned with national standards, our Level 4 qualification ensures you are fully certified and compliant.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Learn on Cutting-Edge Technology</p>
                    <p className="text-gray-700 text-sm">We design and manufacture our own beauty machines, using the latest in laser and IPL technology.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Flexible Training Options</p>
                    <p className="text-gray-700 text-sm">Learn one-on-one or in a group, at our fully equipped academy or in your own salon.</p>
                  </div>
                </div>
              </div>
              
              <a href="mailto:admin@kentacademy.co.uk" className="inline-block bg-gray-800 text-white px-6 py-3 rounded hover:bg-black transition-colors duration-200">
                Enquire About This Course
              </a>
            </div>
            <div className="relative">
              <img 
                src="/assets/Laser2.JPG" 
                alt="Laser and IPL Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Learn - Laser */}
      <section className="py-16 bg-[#f7f6f3]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 md:order-1">
              <img 
                src="/assets/Laser1.jpg" 
                alt="Hands-on Laser Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl md:text-4xl font-light mb-6">
                What You'll <span className="font-semibold">Learn</span>
              </h3>
              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Laser and IPL theory</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Client consultation & contraindications</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Hair growth cycles & treatment planning</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Machine settings & skin typing</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Safety protocols & legislation</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Hands-on practice with live models</p>
                </div>
              </div>
              
              <h4 className="text-xl font-semibold mb-4">Who Can Enroll?</h4>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700">• Qualified beauty therapists (Level 3 or equivalent)</p>
                <p className="text-gray-700">• Medical professionals entering aesthetics</p>
                <p className="text-gray-700">• Salon owners looking to expand their service offerings</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tattoo Removal Course Section */}
      <section id="tattoo" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-light mb-6">
                Level 5 in <span className="font-semibold">Tattoo Removal</span>
              </h2>
              <p className="text-2xl font-semibold text-purple-600 mb-6">CPD & Level 5 Available</p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Master cosmetic and body tattoo removal with our comprehensive training courses. From eyebrow tattoo removal to complex coloured and black ink designs, we provide expert-led, accredited education that prepares you for real-world results.
              </p>
              
              <h3 className="text-xl font-semibold mb-4">Why Train With Us?</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Over 30 Years of Industry Expertise</p>
                    <p className="text-gray-700 text-sm">Learn from seasoned professionals with decades of experience in advanced aesthetics and laser treatments.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Accredited by Focus Awards</p>
                    <p className="text-gray-700 text-sm">Our courses are fully accredited, ensuring you're trained to the highest standards.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Tailored Training Options</p>
                    <p className="text-gray-700 text-sm">CPD Short Courses for beginners or Level 5 advanced qualifications for in-depth expertise.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Remove All Tattoo Types</p>
                    <p className="text-gray-700 text-sm">Learn to remove cosmetic tattoos, black and coloured ink, and complex body art.</p>
                  </div>
                </div>
              </div>
              
              <a href="mailto:admin@kentacademy.co.uk" className="inline-block bg-gray-800 text-white px-6 py-3 rounded hover:bg-black transition-colors duration-200">
                Get Course Pricing
              </a>
            </div>
            <div className="relative">
              <img 
                src="/assets/tattoo.jpg" 
                alt="Tattoo Removal Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Learn - Tattoo */}
      <section className="py-16 bg-[#f7f6f3]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 md:order-1">
              <img 
                src="/assets/Nails1.JPG" 
                alt="Advanced Tattoo Removal Techniques" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl md:text-4xl font-light mb-6">
                What You'll <span className="font-semibold">Master</span>
              </h3>
              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Laser technology & how it targets different pigments</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Skin assessment & treatment planning</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Safety protocols & contraindications</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Practical hands-on training with models</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Aftercare & long-term skin management</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Techniques for different tattoo types and colours</p>
                </div>
              </div>
              
              <div className="bg-white p-4 rounded-lg border border-gray-200">
                <p className="text-gray-700 text-sm">
                  <strong>Course Customisation & Pricing:</strong> Our tattoo removal training is tailored to your experience level and goals. Contact us today for prices — course costs vary depending on prior experience and training format.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vietnamese Nail Courses Section */}
      <section id="nails" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-light mb-6">
                Vietnamese <span className="font-semibold">Nail Courses</span>
              </h2>
              <p className="text-2xl font-semibold text-pink-600 mb-6">Bilingual Training</p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Are you a Vietnamese nail technician working in a UK nail bar? Want to gain official qualifications and meet local council requirements? We offer bilingual (Vietnamese/English) nail technician courses designed specifically for experienced nail workers.
              </p>
              
              <h3 className="text-xl font-semibold mb-4">What We Offer</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Vietnamese-English Speaking Courses</p>
                    <p className="text-gray-700 text-sm">Bilingual delivery with experienced Vietnamese tutors who understand your needs.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Fast-Track Content</p>
                    <p className="text-gray-700 text-sm">Tailored to busy professionals working in nail bars - practical and theory combined.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Council Requirements</p>
                    <p className="text-gray-700 text-sm">Certificates to meet council requirements and UK licensing standards.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Professional Support</p>
                    <p className="text-gray-700 text-sm">Support to register, study, and qualify with confidence to open your own salon.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-3">
                <p className="text-gray-700 font-semibold">📞 07548321022</p>
                <p className="text-gray-700 text-sm italic">Call or message us in Vietnamese or English</p>
                <div className="flex gap-3">
                  <a
                    href="tel:07548321022"
                    className="inline-flex items-center gap-2 border border-gray-400 text-gray-800 px-4 py-2 rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
                  >
                    <PhoneCall size={16} /> Call Now
                  </a>
                  <a
                    href="https://wa.me/447548321022"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 border border-gray-400 text-gray-800 px-4 py-2 rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
                  >
                    <MessageCircle size={16} /> WhatsApp
                  </a>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="/assets/Nails5.JPG" 
                alt="Vietnamese Nail Course Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who Is This For - Nails */}
      <section className="py-16 bg-[#f7f6f3]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 md:order-1">
              <img 
                src="/assets/Nails6.JPG" 
                alt="Vietnamese Nail Technician Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl md:text-4xl font-light mb-6">
                Who Is This <span className="font-semibold">For?</span>
              </h3>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Vietnamese-speaking nail technicians</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Anyone working in a UK nail bar needing qualifications</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Those wanting to open their own salon</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Technicians seeking to meet local council health & safety regulations</p>
                </div>
              </div>
              
              <div className="bg-white p-6 rounded-lg border border-gray-200">
                <h4 className="text-xl font-semibold mb-4">Ready to Get Certified?</h4>
                <p className="text-gray-700 mb-4">
                  Start your journey to becoming a fully qualified nail technician in the UK. Let's get you certified, confident, and ready to grow your career or business!
                </p>
                <p className="text-pink-600 font-semibold">Fast-Track Nail Courses for Vietnamese Learners in the UK</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gray-800 text-white text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h3 className="text-3xl md:text-4xl font-light mb-6">
            Ready to <span className="font-semibold">Transform Your Career?</span>
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Train with the best. Become the best. With our industry background, custom-built technology, and flexible teaching model, we don't just teach you how to do treatments — we prepare you for success.
          </p>
          <a
            href="mailto:admin@kentacademy.co.uk"
            className="inline-block bg-white text-gray-800 px-8 py-3 rounded hover:bg-gray-100 transition-colors duration-200 font-medium"
          >
            Contact Us Today
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <img src="/assets/KaLogo.png" alt="Kent Academy" className="w-14 mb-3" />
            <p className="text-gray-300">
              Kent Academy delivers advanced beauty training with professional-grade equipment and expert guidance.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Courses</h4>
            <ul className="space-y-1 text-gray-400">
              <li>Level 4 in Laser and Light</li>
              <li>Level 5 in Tattoo Removal</li>
              <li>Level 3 in Nail Technology</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Contact</h4>
            <ul className="space-y-1 text-gray-400">
              <li>
                <a href="mailto:admin@kentacademy.co.uk" className="hover:text-gray-300 transition-colors duration-200">
                  admin@kentacademy.co.uk
                </a>
                <li>General: 07548321022</li>
              <li>Vietnamese Courses:07548321022 </li>
              </li>
              <li>Unit 10, Creative Quarter, Javelin Way, Ashford TN24 8FN</li>
              <li>
                <a
                  href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                   className="inline-flex items-center gap-2 text-white hover:underline"
                >
                  <img src="/assets/facebook-icon.png" alt="Facebook" className="w-6 h-6" />
                  facebook.com/KentAcademy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 text-center text-xs text-gray-400">© 2025 Kent Academy. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default Services;